/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core/styles';
import customBreakpoints from '../../../../../../../helpers/customBreakpoints';

const styles = makeStyles((theme) => {
    const { typography } = theme;
    return {
        sizeChartModal: {
            width: '100%',
            maxWidth: '905px',
            margin: 'auto',
            '& .size-chart-modal-header': {
                minHeight: '40px',
            },
            '& svg': {
                '& .b': {
                    clipPath: 'none',
                },
            },
            '& .modal-title': {
                width: '100%',
                height: '8px',
            },
            '& .size-chart-modal': {
                paddingLeft: '40px',
                paddingRight: '40px',
            },
            '& h1': {
                fontFamily: typography.secondaryFontFamily,
                textAlign: 'center',
                textTransform: 'uppercase',
                lineHeight: '38px',
                fontSize: '2.5rem',
                margin: 0,
                marginBottom: '3rem',
            },
            '& .size-chart-title': {
                fontFamily: typography.secondaryFontFamily,
                textAlign: 'center',
                textTransform: 'uppercase',
                lineHeight: '38px',
                fontSize: '2.5rem',
                margin: 0,
                marginBottom: '3rem',
            },
            '& ul': {
                paddingLeft: 20,
                paddingTop: 5,
                margin: 0,
                marginBottom: '1rem',
                '& li': {
                    fontSize: '16px',
                    lineHeight: '20px',
                    fontFamily: typography.fontFamily,

                },
            },
            '& .planter-title': {
                fontFamily: typography.fontFamily,
                fontSize: '24px',
                lineHeight: '20px',
                fontWeight: 700,
                [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                    fontSize: '20px',
                    lineHeight: '20px',
                },
            },
            '& .align-dimension': {
                display: 'flex',
                [theme.breakpoints.between(customBreakpoints.tabPortrait, customBreakpoints.tabLandscape)]: {
                    display: 'unset !important',
                },
                '& > div': {
                    display: 'flex',
                    flexDirection: 'column',
                },
                '& .align-values': {
                    marginLeft: '0.3rem !important',
                },
            },
            '& .close-icon': {
                fontSize: '30px !important',
            },
            '& .pot-images': {
                '& .pot-image-wrapper': {
                    '&:not(:last-child)': {
                        marginRight: '24px',
                    },
                    '& .image-inner-wrapper': {
                        paddingBottom: '20px',
                    },
                    '& .div-disc': {
                        '& p': {
                            marginTop: '0 !important',
                            marginBottom: '0 !important',
                            fontSize: '14.7px',
                            lineHeight: '20px',
                            fontFamily: typography.fontFamily,
                            '&.planter-size': {
                                fontSize: '1rem',
                                fontWeight: '600',
                                clear: 'both',
                            },
                        },
                    },
                },
            },
            '& .last-item-margin': {
                marginBottom: '6rem !important',
            },
            '& hr': {
                margin: '3rem 0',
            },
        },
        [theme.breakpoints.up(customBreakpoints.tabPortrait)]: {
            sizeChartModal: {
                '& .pot-images': {
                    display: 'flex',
                    '& .pot-image-wrapper': {
                        '& .image-inner-wrapper': {
                            '& img': {
                                height: '234px',
                                width: '234px',
                            },
                        },
                        '& .div-disc': {
                            '& p': {
                                marginBottom: '0 !important',
                                '&.planter-size': {
                                    fontFamily: typography.fontFamily,
                                    fontSize: '14.7px',
                                    lineHeight: '20px',
                                    clear: 'both',
                                },
                            },
                        },
                    },
                },
            },
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            sizeChartModal: {
                '& .modal-header': {
                    paddingTop: 0,
                },
                '& .modal-title': {
                    height: '25px',
                    '& .close': {
                        marginTop: '0 !important',
                    },
                },
                '& .size-chart-modal': {
                    padding: '0px 15px ',
                },
                '& h1': {
                    marginBottom: '1.5rem !important',
                },
                '& ul': {
                    paddingBottom: 0,
                    fontSize: '13px',
                    paddingTop: '5px !important',
                    '& li': {
                        fontSize: '16px',
                        lineHeight: '20px',
                        fontFamily: typography.fontFamily,
                    },
                },
                '& .pot-images': {
                    padding: '10px 0',
                    '& .pot-image-wrapper': {
                        '&:not(:last-child)': {
                            marginRight: 0,
                        },
                        display: 'flex',
                        '& >*': {
                            flexGrow: 1,
                            flexBasis: 0,
                        },
                        '& > div': {
                            float: 'left',
                            clear: 'none',
                        },
                        '&:first-child': {
                            '& .image-inner-wrapper': {
                                maxWidth: '100px',
                                marginRight: '12px',
                                '& img': {
                                    width: '96px !important',
                                    height: 'auto !important',
                                    float: 'left',
                                },
                            },
                        },
                        '&:nth-child(2)': {
                            padding: '10px 0',
                            margin: '10px 0',
                            '& .image-inner-wrapper': {
                                maxWidth: '100px',
                                marginRight: '12px',
                                '& img': {
                                    width: '96px !important',
                                    height: 'auto !important',
                                },
                            },
                        },
                        '&:last-child': {
                            '& .image-inner-wrapper': {
                                maxWidth: '100px',
                                marginRight: '12px',
                                '& img': {
                                    width: '96px !important',
                                    height: 'auto !important',
                                },
                            },
                        },
                        '& .image-inner-wrapper': {
                            textAlign: 'center',
                            paddingBottom: '10px',
                            order: 2,
                        },
                        '& p': {
                            width: 'auto',
                            textAlign: 'left',
                            paddingLeft: '0',
                            '& span': {
                                float: 'left',
                                width: '100%',
                            },
                        },
                        '& .div-disc': {
                            width: 'auto',
                            order: 2,
                            textAlign: 'left',
                            paddingLeft: '0',
                            display: 'block',
                            '& span': {
                                width: '100%',
                            },
                            '& p': {
                                marginBottom: '0 !important',
                                fontSize: '14.7px',
                                lineHeight: '20px',
                                fontFamily: typography.fontFamily,
                                [theme.breakpoints.between(348, 428)]: {
                                    fontSize: '12.9px',
                                    lineHeight: '20px',
                                },
                                '&.planter-size': {
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    clear: 'both',
                                },
                            },
                        },
                    },
                },
                '& .note': {
                    marginTop: '10px',
                    marginBottom: '0',
                    fontSize: '13px',
                },
                '& .last-item-margin': {
                    marginBottom: '6rem !important',
                },
                '& hr': {
                    margin: '0px 0 1.5rem',
                },
            },
        },
        [theme.breakpoints.between(customBreakpoints.tabPortrait, customBreakpoints.tabLandscape)]: {
            sizeChartModal: {
                '& .pot-images': {
                    '& .pot-image-wrapper': {
                        '&:not(:last-child)': {
                            marginRight: '50px',
                        },
                        '& p': {
                            paddingLeft: '10px',
                        },
                        '& .div-disc': {
                            paddingLeft: '10px',
                        },
                    },
                },
            },
        },
    };
});

export default styles;
